import { IProps } from '..';

/**
 * 获取座位图入参
 */
export interface SeatRequest {
  /**
   * 影院ID
   */
  cinemaId: string | number;
  /**
   * 影片ID
   */
  movieId: string | number;
  /**
   * 影院名称
   */
  cinemaName: string;
  /**
   * 影片名称
   */
  movieName: string;
  /**
   * 影厅名称
   */
  hallName: string;
  /**
   * 放映时间 格式：yyyy-MM-dd HH:mm:ss
   */
  showDate: string;
  /**
   * 影片语言
   */
  language: string;
  /**
   * 影片维度，2D、3D
   */
  dimensional: string;
  //  下单系统  商城/O2O/百福德
  srcSys?: SrcSysType;
  //  下单来源 PC/H5/小程序
  srcWay?: SrcWayType;
}

/**
 * 获取座位图返回数据
 */
export interface SeatResponse {
  /**
   * 影院名称
   */
  cinemaName?: string;
  /**
   * 影片名称
   */
  movieName?: string;
  /**,
   * 放映时间 格式：yyyy-MM-dd HH:mm:ss
   */
  showDateTime?: string;
  /**
   * 影片语言
   */
  language?: string;
  /**
   * 影厅名称
   */
  hallName?: string;
  /**
   * 维度
   */
  dimensional?: string;
  /**
   * 影片广电码
   */
  movieCode?: string;
  /**
   * 影院专资码
   */
  cinemaCode?: string;
  /**
   * 供应商场次编码
   */
  vendorSessionCode?: string;
  /**
   * 供应商影院编码
   */
  vendorHallCode?: string;
  /**
   * 供应商
   */
  vendor?: number;
  /**
   * 供应商场次ID
   */
  vendorSessionId?: string;
  /**
   * 供应商影院ID
   */
  vendorCinemaId?: string;
  /**,
   * 最大购买票数，默认4张,
   */
  maxPurchaseNum?: number;
  /**
   * 场次最后更新时间，格式：yyyy-MM-dd HH:mm:ss
   */
  lastUpdateTime?: string;
  /**
   * vista院线 1-隆福顺&唐德 2-海上明珠 3-红星美凯龙
   */
  vistaSource?: number;
  /**
   * 参考价格供应商，8-猫眼、9-淘票票
   */
  refVendor?: string | number;
  refPrice?: string | number; //参考价格

  isSuperVipUser?: any, // vip标记
  optimumSelectStrategy?: string | number; //场次选择策略
  /**
   * 是否存在情侣座 true or false
   */
  existLoveSeat?: boolean;
  /**
   * 座位图规则 true 使用行列，false使用坐标
   */
  regular?: boolean;
  sessionKey?: string | number; //供应商场次秘钥
  mobile?: string;
  floors?: [];
  priceCode?: string;
  priceName?: string;
  seats?: originSeat[];
  sectionPrices?: sectionPrice[];
  name?: string; // 后端要求增加
  newSessionInfo?: any; //最新场次信息
}
export interface originSeat {
  seatX: number;
  seatY: number;
  seatDesc: string;
  seatType: number;
  status: number;
  sectionId?: string;
  floorId?: string;
  vendorSeatId?: string;
  vendorSeatX?: number;
  vendorSeatY?: number;
  vendorSeatDesc?: string;
}
export interface NewSeat {
  id: string;
  state: number; // 转后后的新座位状态
  originState: number; // 转后后的新座位状态
  info: string;
  price: number;
  vendorSeatId?: string;
  sectionId?: string;
  vendorSeatDesc?: string;
}
export interface SelectedSeat {
  id: string;
  info: string;
  originState: number;
  position: number;
  price: number;
  state: number;
  sectionId?: string;
  vendorSeatId?: string;
}
export interface sectionPrice {
  price: number;
  dfCostPrice: number;
  settlePrice: number;
  id?: string;
  hallFee?: number;
  serviceFee?: number;
  marketingCode?: number;
}
interface lockSeatInfo {
  sectionId?: string | number; //分区ID
  vendorSeatId?: string | number; //供应商座位ID 必填
  price?: number; //售价，用户实际支付的价格 必填
  settlePrice?: number; // 结算价 必填
  dfCostPrice?: number; // 东福成本价 必填
  desc?: string; // 供应商座位名称，8排8座(老的)
  seatDesc?: string; // 座位名称，8排8座
  vendorSeatDesc?: string; //供应商座位名称，8排8座（新的）
  hallFee?: string | number; // 供应商影厅服务费
  serviceFee?: string | number; //  服务费
  marketingCode?: string; //  活动标识
  seatX?: number; //  座位X值 必填
  seatY?: number; //  座位Y值 必填
  seatType?: number; //  座位type 必填
  vendorSeatX?: string | number; //供应商排号 必填
  vendorSeatY?: string | number; //供应商座位号 必填
}

export interface LockSeatRequest {
  districtId?: string;
  cinemaId?: string | number; // 影院id 必填
  movieId?: string | number; //  影片id 必填
  cinemaName?: string | number; //  影院名称 必填
  movieName?: string; //  影片名称 必填
  hallName?: string; //  影厅名称 必填
  showStartTime?: string; //  放映开始时间，格式yyyy-MM-dd HH:mm:ss 必填
  duration?: number; //  时长，单位 分钟 必填
  vendor?: any; //  供应商 必填
  vendorSessionId?: any; //  供应商场次ID 必填
  vendorCinemaId?: any; //  供应商影院ID 必填
  movieCode?: any; //  影片广电码
  cinemaCode?: any; //  影院专资码
  vendorSessionCode?: any; //  供应商场次编码
  vendorHallCode?: any; //  供应商影院编码
  srcSys?: SrcSysType; //  下单系统  商城/O2O/百福德
  srcWay?: SrcWayType; //  下单来源 PC/H5/小程序
  refVendor?: any; //  参考价格供应商，8-猫眼、9-淘票票 ====
  refPrice?: string | number; //参考价格
  optimumSelectStrategy?: string | number; //场次选择策略
  language?: any; //  语言 1-中文 2-双语
  dimensional?: any; //  影片维度，2D、3D
  sessionLastUpdateTime?: any; //  场次最后更新时间，格式：yyyy-MM-dd HH:mm:ss
  vistaSource?: any; //  vista院线 1-隆福顺&唐德 2-海上明珠 3-红星美凯龙
  priceCode?: any; //  票类
  priceName?: any; //  票类名称
  idNo?: number; //  证件号
  idType?: string | number; //  证件类型 1-身份证 2-护照 3-台胞证 4-港澳台通行证
  userName?: string; //  观影人姓名
  userMobile?: number; //  手机号
  ticketMobile?: number | string; // 取票手机号
  sessionKey?: number | string; //供应商场次秘钥
  paySuccessUrl?: string; // 支付完回调域名
  seats?: lockSeatInfo[];
  name?: string;
}

export enum SrcSysType { //1-www 2-020 3-400 4-百福德
  WWW = 1,
  O2O,
  T400,
  BFD,
}

export enum SrcWayType { // 1-PC 2-小程序 3-H5
  PC = 1,
  MiniProgram,
  H5,
}
